import { render, staticRenderFns } from "./DashboardUserProfileStatus.vue?vue&type=template&id=22aab746&scoped=true"
import script from "./DashboardUserProfileStatus.vue?vue&type=script&lang=ts"
export * from "./DashboardUserProfileStatus.vue?vue&type=script&lang=ts"
import style0 from "./DashboardUserProfileStatus.vue?vue&type=style&index=0&id=22aab746&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22aab746",
  null
  
)

export default component.exports